import { __rest } from "tslib";
import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { FolderThunks_sd } from '@web-mail/state/slice/subordinateMailReducer/thunks/folderThunks_sd';
import { SearchThunks_sd } from '@web-mail/state/slice/subordinateMailReducer/thunks/searchThunk_sd';
import { MailListThunks_cm } from '@web-mail/state/slice/customerMailReducer/thunks/listThunk_cm';
import { getSubordinateSlice } from '@web-mail/utils/slice';
import { request } from '@web-mail/state/slice/request';
const ReducerName = 'SubordinateBoxReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'refreshMailContent_sd',
    request: async ({ sliceId }, thunkAPI) => {
        const rootState = thunkAPI.getState().mailReducer;
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        const _a = state.selectedMailId, { id: mid } = _a, params = __rest(_a, ["id"]);
        if (mid) {
            await request.doGetTpMailContent(Object.assign(Object.assign({}, params), { mid }), true);
        }
    },
    pending: (rootState, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
    },
    fulfilled: (rootState, action) => {
        const { sliceId } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
    },
});
thunkHelper({
    name: 'refreshPage_sd',
    request: async ({ sliceId }, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const rootState = thunkAPI.getState().mailReducer;
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        const subordinateListLength = state.subordinateList.length;
        const subordinateTreeListLength = state.subordinateTreeList.length;
        if (!!state.mailSearchState) {
            if (!!state.searchLoading || !!state.advancedSearchLoading) {
                return;
            }
            if (state.mailSearchState === 'server') {
                await dispatch(SearchThunks_sd.searchMailList_sd({
                    startIndex: 0,
                    showLoading: true,
                    sliceId,
                }));
            }
            else if (state.mailSearchState === 'advanced') {
                await dispatch(SearchThunks_sd.advancedSearchMailList_sd({
                    startIndex: 0,
                    showLoading: true,
                    sliceId,
                }));
            }
            else if (state.mailSearchState === 'more_server') {
                await dispatch(SearchThunks_sd.searchMailList_sd_more({
                    startIndex: 0,
                    showLoading: true,
                    sliceId,
                }));
            }
            else if (state.mailSearchState === 'more_advanced') {
                await dispatch(SearchThunks_sd.advancedSearchMailList_sd_more({
                    startIndex: 0,
                    showLoading: true,
                    sliceId,
                }));
            }
            else if (state.mailSearchState === 'more_AI') {
                await dispatch(SearchThunks_sd.doExtractMailFromAI({}));
                if (subordinateListLength === 0 || subordinateTreeListLength === 0) {
                    await dispatch(FolderThunks_sd.loadFolderData_sd({
                        noCache: true,
                        showLoading: false,
                        sliceId,
                    }));
                    const rootState = thunkAPI.getState().mailReducer;
                    const state = getSubordinateSlice(rootState, sliceId);
                    if (!state) {
                        return;
                    }
                    await dispatch(FolderThunks_sd.getColleagueFolderList_sd({
                        id: state.selectedFolder.subordinateId,
                        sliceId,
                        refresh: true,
                    }));
                }
            }
        }
        else {
            await dispatch(FolderThunks_sd.loadFolderData_sd({
                noCache: true,
                showLoading: false,
                sliceId,
            }));
            const rootState = thunkAPI.getState().mailReducer;
            const state = getSubordinateSlice(rootState, sliceId);
            if (!state) {
                return;
            }
            await dispatch(FolderThunks_sd.getColleagueFolderList_sd({
                id: state.selectedFolder.subordinateId,
                sliceId,
                refresh: true,
            }));
            await dispatch(MailListThunks_cm.loadMailList_edm({
                showLoading: true,
                noCache: true,
                refresh: true,
                type: 'subordinate',
                sliceId,
            }));
            await dispatch(Thunks.refreshMailContent_sd({
                sliceId,
                refresh: true,
            }));
        }
    },
    pending: (rootState, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        state.refreshBtnLoading = true;
        state.subordinateListLoading = true;
        state.listLoading = true;
    },
    fulfilled: (rootState, action) => {
        const { sliceId } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        state.refreshBtnLoading = false;
        state.subordinateListLoading = false;
        state.listLoading = false;
    },
    rejected: (rootState, action) => {
        var _a;
        const { showMessage = true, sliceId } = action.meta.arg || {};
        if (showMessage) {
            const errorMessage = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
            reduxMessage.success({ content: errorMessage });
        }
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        state.refreshBtnLoading = false;
        state.subordinateListLoading = false;
    },
});
export const MailBoxThunks_sd = Thunks;
export const MailBoxExtraReducersList_sd = ReducersList;
